(function () {
  'use strict';
  svgedit.history = svgedit.history || {};

    // Class: svgedit.history.InsertElementCommand
    // implements svgedit.history.HistoryCommand
    // History command for an element that was added to the DOM
    //
    // Parameters:
    // elem - The newly added DOM element
    // text - An optional string visible to user related to this change
  svgedit.history.InsertElementCommand = function (elem, text) {
    this.elem = elem;
    this.text = text || ('Create ' + elem.tagName);
    this.parent = elem.parentNode;
    this.nextSibling = this.elem.nextSibling;
  };
  svgedit.history.InsertElementCommand.type = function () { return 'svgedit.history.InsertElementCommand'; };
  svgedit.history.InsertElementCommand.prototype.type = svgedit.history.InsertElementCommand.type;

    // Function: svgedit.history.InsertElementCommand.getText
  svgedit.history.InsertElementCommand.prototype.getText = function () {
    return this.text;
  };

    // Function: svgedit.history.InsertElementCommand.apply
    // Re-Inserts the new element
  svgedit.history.InsertElementCommand.prototype.apply = function (handler) {
    if (handler) {
      handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.BEFORE_APPLY, this);
    }

    this.elem = this.parent.insertBefore(this.elem, this.nextSibling);

    if (handler) {
      handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.AFTER_APPLY, this);
    }
  };

    // Function: svgedit.history.InsertElementCommand.unapply
    // Removes the element
  svgedit.history.InsertElementCommand.prototype.unapply = function (handler) {
    if (handler) {
      handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.BEFORE_UNAPPLY, this);
    }

    this.parent = this.elem.parentNode;
    this.elem = this.elem.parentNode.removeChild(this.elem);

    if (handler) {
      handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.AFTER_UNAPPLY, this);
    }
  };

    // Function: svgedit.history.InsertElementCommand.elements
    // Returns array with element associated with this command
  svgedit.history.InsertElementCommand.prototype.elements = function () {
    return [this.elem];
  };
})();
